export default "__VITE_ASSET__D$3S8oiJ__"